import { InterceptedCoroutine142wh200e9wbr as InterceptedCoroutine } from '../InterceptedCoroutine.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../Standard.mjs';
import { GeneratorCoroutineImpl2pzxhv55we2g3 as GeneratorCoroutineImpl } from '../GeneratorCoroutineImpl.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function intercepted(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4 instanceof InterceptedCoroutine() ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ad();
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
function invokeSuspendSuperTypeWithReceiver(_this__u8e3s4, receiver, completion) {
  throw NotImplementedError().md('It is intrinsic method');
}
function invokeSuspendSuperType(_this__u8e3s4, completion) {
  throw NotImplementedError().md('It is intrinsic method');
}
function invokeSuspendSuperTypeWithReceiverAndParam(_this__u8e3s4, receiver, param, completion) {
  throw NotImplementedError().md('It is intrinsic method');
}
function createCoroutineUninterceptedGeneratorVersion(_this__u8e3s4, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  var tmp = continuation;
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  tmp.uc_1 = typeof a === 'function' ? a(continuation) : _this__u8e3s4.nd(continuation);
  return continuation;
}
function createCoroutineUninterceptedGeneratorVersion_0(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  var tmp = continuation;
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  tmp.uc_1 = typeof a === 'function' ? a(receiver, continuation) : _this__u8e3s4.od(receiver, continuation);
  return continuation;
}
function startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  var generator = typeof a === 'function' ? a(receiver, continuation) : _this__u8e3s4.od(receiver, continuation);
  continuation.uc_1 = generator;
  return continuation.xc();
}
function startCoroutineUninterceptedOrReturnGeneratorVersion_0(_this__u8e3s4, receiver, param, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  var generator = typeof a === 'function' ? a(receiver, param, continuation) : _this__u8e3s4.pd(receiver, param, continuation);
  continuation.uc_1 = generator;
  return continuation.xc();
}
//region block: exports
export {
  createCoroutineUninterceptedGeneratorVersion as createCoroutineUninterceptedGeneratorVersion1ji2no4l6ift5,
  createCoroutineUninterceptedGeneratorVersion_0 as createCoroutineUninterceptedGeneratorVersion2gduom218i9ay,
  intercepted as intercepted2ogpsikxxj4u0,
  startCoroutineUninterceptedOrReturnGeneratorVersion as startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn,
  startCoroutineUninterceptedOrReturnGeneratorVersion_0 as startCoroutineUninterceptedOrReturnGeneratorVersion36jld8bkc4ba2,
};
//endregion

//# sourceMappingURL=IntrinsicsJs.mjs.map
